import React, { Fragment } from 'react';

import { InputLabel, MenuItem, FormControl, Select, Typography } from '@material-ui/core';

import ListaHorarios from '../../BotonListaHorarios';

import useStyles from './styles';

export default ({ estaciones, fieldSelected, setDataSearchServicio }) => {
  const classes = useStyles();

  const lineas = estaciones;

  return (
    <Fragment>
      <Typography variant='h6' className={classes.titleSection}>
        Seleccioná la línea en la que viajás
      </Typography>
      <FormControl variant='outlined' className={classes.formControl}>
        <InputLabel id='selected-linea-label'>Seleccione Linea</InputLabel>
        <Select
          labelId='selected-linea-label'
          id='selected-linea'
          value={fieldSelected}
          onChange={setDataSearchServicio}
          label='Seleccione Linea'
          name='linea'
        >
          {lineas &&
            lineas.map((linea) => (
              <MenuItem key={linea.ramal_id} value={linea.ramal_id}>
                {linea.ramal_nombre}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <ListaHorarios linea={fieldSelected} className={classes.fRight} />
    </Fragment>
  );
};
